export default {
  name: "dummyData",
  markets: [
    {
      id: 1,
      name: "test markt 1",
      start_date: "2021-04-01",
      end_date: "2021-04-02",
      infotext: "Lorem ipsum dolor sit amet",
      link: ""
    }
  ],
  images: [
    {
      id: 1,
      order: 10,
      slug: "products",
      file: "DSC04929.jpg",
      description: "",
    },
    {
      id: 2,
      order: 20,
      slug: "products",
      file: "DSC04992.jpg",
      description: "",
    },
    {
      id: 3,
      order: 30,
      slug: "products",
      file: "DSC04999.jpg",
      description: "",
    },
    {
      id: 4,
      order: 40,
      slug: "products",
      file: "DSC05005.jpg",
      description: "",
    },
    {
      id: 5,
      order: 50,
      slug: "products",
      file: "DSC05007.jpg",
      description: "",
    },
    {
      id: 6,
      order: 60,
      slug: "products",
      file: "DSC05012.jpg",
      description: "",
    },
    {
      id: 7,
      order: 70,
      slug: "products",
      file: "DSC05014.jpg",
      description: "",
    },
    {
      id: 8,
      order: 80,
      slug: "products",
      file: "DSC05024.jpg",
      description: "",
    },
    {
      id: 9,
      order: 90,
      slug: "products",
      file: "DSC05028.jpg",
      description: "",
    },
    {
      id: 10,
      order: 100,
      slug: "products",
      file: "DSC05035.jpg",
      description: "",
    },
    {
      id: 11,
      order: 110,
      slug: "products",
      file: "DSC05038.jpg",
      description: "",
    },
    {
      id: 12,
      order: 120,
      slug: "products",
      file: "DSC05057.jpg",
      description: "",
    },
    {
      id: 13,
      order: 130,
      slug: "products",
      file: "DSC05063.jpg",
      description: "",
    },
    {
      id: 14,
      order: 140,
      slug: "products",
      file: "DSC05068.jpg",
      description: "",
    },
    // {
    //   id: 15,
    //   order: 150,
    //   slug: "products",
    //   file: "DSC05072.jpg",
    //   description: "",
    // },
    {
      id: 16,
      order: 160,
      slug: "products",
      file: "DSC05077.jpg",
      description: "",
    },
    {
      id: 20,
      order: 10,
      slug: "slideshow",
      file: "DSC05689.jpg",
      description: "",
    },
    {
      id: 21,
      order: 20,
      slug: "slideshow",
      file: "DSC05752.jpg",
      description: "",
    },
    {
      id: 22,
      order: 30,
      slug: "slideshow",
      file: "DSC05991.jpg",
      description: "",
    },
    {
      id: 23,
      order: 40,
      slug: "slideshow",
      file: "DSC06040.jpg",
      description: "",
    },
    {
      id: 24,
      order: 50,
      slug: "slideshow",
      file: "DSC06048.jpg",
      description: "",
    },
    {
      id: 25,
      order: 60,
      slug: "slideshow",
      file: "DSC06093.jpg",
      description: "",
    }
  ],
  texts: [
    {
      slug: "ProduktGallerie",
      title: "Eine Auswahl an Produktfotos",
      text:
        "Diese hübschen Tassen können Sie fei bei mir kaufen, Sie müssen blos anrufen!"
    },
    {
      slug: "about",
      title: "Hanna Grimm-Müller",
      text:
        "ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    },
    {
      slug: "infoBlock",
      title: "Was bedeutet eigentlich freigedreht?",
      text:
        "ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    }
  ]
};
